module.exports = __webpack_public_path__ + "img/no-auth.6d67fb0f.png";